const _ = require('lodash');
const domainModel = require('domain-model');

function createIsAcceptableAlcoholTaxFilter(entity) {
  const productCategory = _.get(entity, 'productCategory');

  if (productCategory) {
    const possibleAlcoholTaxClasses =
      domainModel.article.productCategoryTree.getInheritedProperty(
        productCategory,
        'alcoholTaxClasses',
      );
    return option => _.includes(possibleAlcoholTaxClasses, option.value);
  }
  return () => true;
}

function showAlcoholTaxField(entity) {
  const productCategory = _.get(entity, 'productCategory');
  if (productCategory) {
    const possibleAlcoholTaxClasses =
      domainModel.article.productCategoryTree.getInheritedProperty(
        productCategory,
        'alcoholTaxClasses',
      ) || [];
    return possibleAlcoholTaxClasses.length !== 1;
  }
  return true;
}
function isFieldImmutable(entity, field) {
  const productCategory = _.get(entity, 'productCategory');
  if (productCategory) {
    const immutableField = `immutableFields.${field}`;
    const foundProperty =
      domainModel.article.productCategoryTree.getInheritedProperty(
        productCategory,
        immutableField,
      );
    return foundProperty !== undefined;
  }
  return false;
}
module.exports = {
  createIsAcceptableAlcoholTaxFilter,
  showAlcoholTaxField,
  isFieldImmutable,
};
